import React from 'react'
import styled from 'styled-components'

import HoveredSeriesValue from 'pages/Device/ThermostatRthPanel/Legend/HoveredSeriesValue'
import CheckMark from 'pages/Device/ThermostatRthPanel/Legend/CheckMark'
import SeriesLabel from 'pages/Device/ThermostatRthPanel/Legend/SeriesLabel'

import { AlertsLegendItem, LegendItem, legendDataForTimeAtCursor } from 'types/RuntimeHistory'

type Props = {
  noDataText?:string
  legendItem: Required<LegendItem> | Required<AlertsLegendItem>
  selectedLegendItems: Required<Array<string>>
  onClickCheckmarkCallback: (e) => void
  legendDataForTimeAtCursor?: Required<legendDataForTimeAtCursor> | null
  isSelected: boolean
}
const LegendGroupItem = ({ noDataText = 'No Data', legendItem: item, isSelected, legendDataForTimeAtCursor, onClickCheckmarkCallback }: Props) => {
  const getLegendData = () => {
    if (legendDataForTimeAtCursor) {
      if (legendDataForTimeAtCursor[item.seriesName]) {
        return legendDataForTimeAtCursor[item.seriesName]
      } else {
        return '--'
      }
    }
  }

  return (
    <S.LegendItem>
      <SeriesLabel isSelected={isSelected} series={item} disable={item.emptyDataSet} onSelectSeriesCallback={onClickCheckmarkCallback} />
      <S.DisplayValue>
        {
        item.emptyDataSet ? <S.NoData data-testid={item.seriesName} aria-label={'no data for ' + item.seriesName}>{noDataText}</S.NoData>
          : legendDataForTimeAtCursor
            ? <HoveredSeriesValue isSelected={isSelected} series={item} getLegendDataCallback={getLegendData} />
            : <CheckMark isSelected={isSelected} seriesName={item.seriesName} onSelectCallback={onClickCheckmarkCallback} />
        }
      </S.DisplayValue>
    </S.LegendItem>
  )
}

export default LegendGroupItem

const S = {
  LegendItem: styled.div`
    display: grid;
    grid-template-columns: 67% 33%;
    grid-column-gap: 5px;
    margin-bottom: 5px;
`,
  DisplayValue: styled.div`
    display:  flex;
    margin: 0 auto;
`,
  NoData: styled.span`
    opacity: 0.4;
`
}
